import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export interface PagedResult<T> {
	data: T[];
	total: number;
}

export const all = async (
	globalSearch: string = '',
	tab: string = 'active',
	tabSearch: string = '',
	startDate?: Date | null,
	endDate?: Date | null,
	sorting?: SortingState,
	pagination: PaginationState = { pageIndex: 0, pageSize: 10 },
): Promise<PagedResult<Dex360Audit>> => {
	const params = new URLSearchParams();

	if (globalSearch) params.append('globalSearch', globalSearch);
	if (tab) params.append('tab', tab);
	if (tabSearch) params.append('tabSearch', tabSearch);
	if (startDate) params.append('startDate', startDate.toISOString());
	if (endDate) params.append('endDate', endDate.toISOString());

	params.append('pageIndex', (pagination.pageIndex + 1).toString());
	params.append('pageSize', pagination.pageSize.toString());

	if (sorting && sorting.length > 0) {
		const sort = sorting[0];
		if (sort.id === 'error' || sort.id === 'errorDate') {
			params.append('sortBy', sort.id);
			params.append('sortDirection', sort.desc ? 'desc' : 'asc');
		}
	}
	const response = await fetch(`/Dex360Audit/DexErrors?${params}`);
	if (!response.ok) throw new Error('Failed to fetch Dex errors');
	return await response.json();
};

export const SetExceptionsHidden = async (
	ids: number[],
	hide: boolean,
): Promise<boolean> => {
	const res = await fetch(`/Dex360Audit/SetExceptionsHidden`, {
		method: 'PATCH',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ exceptionIds: ids, hide }),
	});
	return res.ok;
};

export const Dex360AuditSchema = z.object({
	id: z.number().nullable(),
	accountId: z.string().nullable(),
	locations: z.array(z.string()).nullable(),
	locationsDisplay: z.string().nullable(),
	producerName: z.string().nullable(),
	error: z.string().nullable(),
	errorDate: z.date().nullable(),
	isResolved: z.boolean().nullable(),
	isHidden: z.boolean().nullable(),
	status: z.string().nullable(),
});

export type Dex360Audit = z.infer<typeof Dex360AuditSchema>;
